import { render } from "./EventRegistrationPage.vue?vue&type=template&id=6b912b82&scoped=true"
import script from "./EventRegistrationPage.vue?vue&type=script&lang=js"
export * from "./EventRegistrationPage.vue?vue&type=script&lang=js"

import "./EventRegistrationPage.vue?vue&type=style&index=0&id=6b912b82&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b912b82"]])

export default __exports__